export const TOOLTIP_CONTENT = {
  discussionQuestions:
    "Show answers to students. Discussion questions are always visible.",
  vocabularyDefinitions:
    "Show vocabulary definitions to students. Vocabulary words are always visible.",
  videoOnly: "Show Video player without the activity panel.",
} as const;
